import { oc } from '@orpc/contract';
import { logoutInputSchema, logoutOutputSchema } from '../schemas/auth.schemas.js';
export const logoutUserContract = oc
    .route({
    method: 'POST',
    path: '/auth/logout',
    tags: ['Auth'],
    summary: 'Revoke the presented refresh token (this device only)',
})
    .input(logoutInputSchema)
    .output(logoutOutputSchema);
//# sourceMappingURL=logout-user.contract.js.map